import { Datagrid, ExportButton, List, ReferenceField, SearchInput, TextField, TopToolbar } from 'react-admin';
import { useBulkActionButtons } from '../deleteControls';
import StartRequestButtons from "./StartRequestButtons";
import exporter from "./exporter";

const ListActions = () => (
    <TopToolbar>
        {/* #109 - the default export cap is 1,000 rows; the agent book is ~11k. */}
        <ExportButton maxResults={25000}/>
    </TopToolbar>
);

// #43 — find whether an agent is already in the system. Partial match on
// name, email, or NPN (the backend q handler).
const agentFilters = [
    <SearchInput source="q" placeholder="Name, email, or NPN" alwaysOn />,
];

export const AgentList = () => {
  const bulkActionButtons = useBulkActionButtons();
  return (
    <List perPage={25} actions={<ListActions />} filters={agentFilters} exporter={exporter}>
        <Datagrid rowClick="show" bulkActionButtons={bulkActionButtons}>
            <TextField source="npn" />
            <TextField source="email" />
            <TextField source="firstName" />
            <TextField source="lastName" />
            <ReferenceField source="agency" reference="agency" label="Agency" emptyText="—" link={false}>
                <TextField source="name" />
            </ReferenceField>
            {/* #57 - principal-only column: start a request for this agent. */}
            <StartRequestButtons label="" />
        </Datagrid>
    </List>
  );
};

export default AgentList;
